import { render, staticRenderFns } from "./logCard.vue?vue&type=template&id=b489b4b8&scoped=true&"
import script from "./logCard.vue?vue&type=script&lang=js&"
export * from "./logCard.vue?vue&type=script&lang=js&"
import style0 from "./logCard.vue?vue&type=style&index=0&id=b489b4b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b489b4b8",
  null
  
)

export default component.exports